import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import FAQBody from "./Components/BodyFAQ";

class DEFAQ extends React.Component {
    render() {
        return (<>
            <Nav />
            <FAQBody />
            <Footer />
        </>
        );

    }
}

export default DEFAQ;